export type VerifyEmailResult = {
    data: {
        verifyEmail: boolean | null;
    };
};

export const verifyEmailMutation = `
  mutation VerifyEmail($token: String!) {
    verifyEmail(emailVerificationToken: $token)
  }
`;


